import { useTranslation } from "react-i18next";

import { IconUserMinus02 } from "@pentabd/icons";
import { Header } from "@pentabd/ui";

import { ROUTES } from "@constants/routes";

const {
  HRM: { RETIREMENTS },
} = ROUTES;

export const ReleaseDetailsPageHeader = () => {
  const { t } = useTranslation();

  const breadcrumbs = [
    {
      icon: <IconUserMinus02 size="20" />,
    },
    {
      label: t("RELEASE_DETAILS.BREADCRUMBS.FIRST_STEP"),
      link: RETIREMENTS,
    },
    {
      label: t("RELEASE_DETAILS.BREADCRUMBS.SECOND_STEP"),
    },
  ];

  const headerText = {
    header: t("RELEASE_DETAILS.HEADING"),
    subHeader: t("RELEASE_DETAILS.DESCRIPTION"),
  };

  return (
    <div className="p-10">
      <Header breadcrumbs={breadcrumbs} headerText={headerText} />
    </div>
  );
};
